var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5H4.11409C6.04466 2.79137 8.15921 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11H0C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C7.78663 0 5.23708 0.910558 3 3.25645V0.991211H1V7H7V5ZM16 10H12V5H10V12H16V10Z",
    fill: "#E1BB41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowClock);
export default __webpack_public_path__ + "static/media/yellowClock.5361054977951ff801eabce348137635.svg";
export { ForwardRef as ReactComponent };